/**
 * Utility to clear V9 channel filter localStorage keys
 * Called on login and logout to ensure fresh filter state
 */

/**
 * Clears V9 channel filter localStorage keys
 * Called on login and logout to reset channel selections
 *
 * This only clears channel filters, NOT date ranges or saved segments.
 * Date ranges and saved segments are preserved across login/logout sessions.
 */
export const clearV9ChannelFilters = (): void => {
  try {
    // Clear all page-specific channel filters
    localStorage.removeItem('alley-hooper-v9-channel-filters-brand-health');
    localStorage.removeItem('alley-hooper-v9-channel-filters-companies-insight');
    localStorage.removeItem('alley-hooper-v9-channel-filters-sponsorship-value');
  } catch (error) {
    // Fail silently if localStorage is disabled (private browsing)
    console.error('[clearV9Filters] Failed to clear filters:', error);
  }
};

/**
 * Optional: Clear ALL V9 filters including date ranges
 * Use this if you want to completely reset the V9 state
 *
 * Currently not used - keeping date ranges persistent improves UX
 */
export const clearAllV9Filters = (): void => {
  try {
    clearV9ChannelFilters();

    // Also clear date range and segment selections
    localStorage.removeItem('alley-hooper-v9-filters');
  } catch (error) {
    console.error('[clearV9Filters] Failed to clear all filters:', error);
  }
};
